import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { useMediaQuery } from '@mui/material';

const Day1BranchWise = () => {
  const branchData = [
    { id: 'CSE', value: 24 },
    { id: 'Double Major Mining+CSE', value: 3 },
    { id: 'M&C', value: 9 },
    { id: 'Petro', value: 29 },
    { id: 'ECE', value: 24 },
    { id: 'Mech', value: 23 },
    { id: 'EE', value: 16 },
    { id: 'Mining', value: 7 },
    { id: 'Enviro', value: 5 },
    { id: 'AGP', value: 5 },
    { id: 'Chem', value: 4 },
    { id: 'AGL', value: 3 },
    { id: 'Civil', value: 3 },
    { id: 'EP', value: 1 },
    { id: 'MME', value: 1 },
    { id: 'MLMTE', value: 2 },
    { id: 'MBA', value: 5 },
    { id: 'B.Tech Chem+ M.Tech CSE', value: 1 },
    { id: 'B.Tech Enviro+ M.Tech CSE', value: 1 },
  ];

  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const isMediumScreen = useMediaQuery('(max-width:900px)');

  const chartWidth = isSmallScreen ? 300 : isMediumScreen ? 600 : 800;
  const chartHeight = isSmallScreen ? 300 : isMediumScreen ? 500 : 600;

  const valueFormatter = (data) => `${data.id}: ${data.value} students`;

  return (
    <div
      style={{
        marginTop: '1em',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <h2
        style={{
          fontSize: 'clamp(1.5rem, 2vw, 2.5rem)',
          marginBottom: '1rem',
          color: 'rgba(238, 79, 152, 1)',
        }}
      >
        Day 1 - Branch-Wise
      </h2>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center', // Center-align chart
          alignItems: 'center',
          width: '100%',
          padding: '20px', // Add padding for spacing
        }}
      >
        {/* Pie Chart */}
        <PieChart
          series={[
            {
              data: branchData,
              highlightScope: { fade: 'global', highlight: 'item' },
              faded: {
                innerRadius: 60,
                additionalRadius: -20,
                color: 'gray',
              },
              valueFormatter,
            },
          ]}
          margin={{
            left: 10, // Minimal margins
            top: 10,
            right: 10,
            bottom: 10,
          }}
          width={chartWidth}
          height={chartHeight}
        />
      </div>
    </div>
  );
};

export default Day1BranchWise;
